export const product = {
  name: 'Le Jazz Master',
  tagline: 'Le système complet « Imprimez & Enseignez »',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a523d719-2033-4910-9f82-1604752e61bc.jpg',
  description:
    'Le fil conducteur de tout votre enseignement : un programme de 36 semaines, niveau par niveau, pour savoir exactement quoi enseigner à chaque cours.',
  value: 67,
};

export const productModules = [
  'Programme de 36 semaines, du niveau débutant au niveau avancé',
  'Fiches de cours prêtes à imprimer pour chaque semaine',
  'Exercices de comping, d’improvisation et de répertoire',
  'Feuilles de devoirs et suivi des progrès des élèves',
];
